import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const TollIdentifier = ({ roles }) => {

    return (
        <M_Table entityName={'Toll'} filtersOnTable rolePermissions={roles} />
    )
}